import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SendViaType = 'text' | 'email' | 'both' | '';

const initialState = {
  activeStep: 0,
  messageCountLoading: false,
  selected: {
    all: false,
    user: true,
    organizers: true,
  },
  sendDialogOpen: false,
  sendVia: '' as SendViaType,
  successDialogOpen: false,
};

export const sendAnnouncementSlice = createSlice({
  name: 'sendAnnouncementSlice',
  initialState,
  reducers: {
    initialize: () => initialState,
    // activeStep...
    decrementActiveStep: state => {
      state.activeStep = state.activeStep - 1;
    },
    incrementActiveStep: state => {
      state.activeStep = state.activeStep + 1;
    },
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
    setMessageCountLoading: (state, action: PayloadAction<boolean>) => {
      state.messageCountLoading = action.payload;
    },
    setSuccessDialogOpen: () => {
      return {
        ...initialState,
        successDialogOpen: true,
      };
    },
    // selected...
    setSelectedAll: (state, action: PayloadAction<boolean>) => {
      state.selected.all = action.payload;
    },
    setSelectedUser: (state, action: PayloadAction<boolean>) => {
      state.selected.user = action.payload;
    },
    setSelectedOrganizers: (state, action: PayloadAction<boolean>) => {
      state.selected.organizers = action.payload;
    },
    // sendDialogOpen...
    setSendDialogOpen: state => {
      state.sendDialogOpen = true;
    },
    // sendVia...
    setSendVia: (state, action: PayloadAction<SendViaType>) => {
      state.sendVia = action.payload;
    },
  },
});
